import { useAppSelector } from "../../../redux/store";
import { Section } from "../../../types/types";

export const useBoardSections = (
  filteredData: any[],
  configSections: string[] | undefined,
  statusOptions: any[] | undefined,
  reorderingField?: string,
) => {
  const state = useAppSelector((state) => state.auth);
  const sections: Section[] =
    configSections?.map((item) => ({
      title: item,
      data: [],
    })) || [];

  filteredData.forEach((doc) => {
    const section = sections.find(
      (item) => item.title === doc.columnName || item.title === doc.status,
    );
    if (section) {
      section.data.push(doc);
    }
  });

  if (reorderingField) {
    sections.forEach((section) => {
      section.data = section.data
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
          const aOrder = a.item[reorderingField];
          const bOrder = b.item[reorderingField];

          if (aOrder !== bOrder) {
            return aOrder - bOrder;
          }

          return a.index - b.index;
        })
        .map(({ item }) => item);
    });
  }

  if (!statusOptions) {
    return sections;
  }

  return sections.filter((section) => {
    const status = statusOptions.find(
      (statusOption) => statusOption.value === section.title,
    );
    return status?.visibleBy.includes(state.user.role);
  });
};
